document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('.mobile-nav');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.setAttribute('aria-hidden', String(open));
      menu.classList.toggle('is-open', !open);
    });
  }

  const shopMenu = document.querySelector('[data-shop-menu]');
  const shopTrigger = document.querySelector('[data-shop-trigger]');
  if (shopMenu && shopTrigger) {
    let suppressFocusOpen = false;
    const setShopOpen = (open) => {
      shopMenu.classList.toggle('is-open', open);
      shopTrigger.setAttribute('aria-expanded', String(open));
    };

    shopMenu.addEventListener('mouseenter', () => setShopOpen(true));
    shopMenu.addEventListener('mouseleave', () => setShopOpen(false));
    shopMenu.addEventListener('focusin', () => {
      if (!suppressFocusOpen) setShopOpen(true);
    });
    shopMenu.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!suppressFocusOpen) setShopOpen(shopMenu.contains(document.activeElement));
      }, 0);
    });
    shopMenu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        suppressFocusOpen = true;
        setShopOpen(false);
        shopTrigger.focus();
        window.setTimeout(() => {
          suppressFocusOpen = false;
          setShopOpen(false);
        }, 0);
      }
    });
  }

  document.querySelectorAll('[data-shape-tabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const panels = [...root.querySelectorAll('[role="tabpanel"]')];
    tabs.forEach((tab, index) => tab.addEventListener('click', () => {
      tabs.forEach((item, i) => {
        const active = i === index;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel, i) => panel.hidden = i !== index);
    }));
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const price = document.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  });
});
